import { render, staticRenderFns } from "./Reaccreditation.vue?vue&type=template&id=568f785d&"
import script from "./Reaccreditation.vue?vue&type=script&lang=js&"
export * from "./Reaccreditation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports